(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Announcement rotation */
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2 || reduceMotion) {
      if (reduceMotion) items.forEach((i) => i.classList.add('is-active'));
      return;
    }
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Close mobile drawer on Escape */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-drawer][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* Gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-slide]');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.thumb;
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.slide === index));
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        slides.forEach((s) => s.querySelectorAll('video').forEach((v) => v.pause()));
      });
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    qty.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* Variant offers: update price, button and URL */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const radios = form.querySelectorAll('input[type="radio"][name="id"]');
    if (!radios.length) return;
    const priceNow = form.querySelector('.price__now');
    const button = form.querySelector('[data-add-button]');
    const label = button ? button.textContent.trim() : '';
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (priceNow) priceNow.textContent = radio.dataset.price;
        let was = form.querySelector('.price__was');
        if (radio.dataset.compare) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'price__was';
            priceNow.after(was);
          }
          was.textContent = radio.dataset.compare;
        } else if (was) {
          was.remove();
        }
        const available = radio.dataset.available === 'true';
        if (button) {
          button.disabled = !available;
          button.textContent = available ? label : 'Épuisé';
        }
        if (form.closest('[data-product-section]')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
          const sticky = document.querySelector('[data-sticky-buy] .price__now');
          if (sticky) sticky.textContent = radio.dataset.price;
        }
      });
    });
  });

  /* Sticky buy bar: visible once the main button scrolls out of view */
  const sticky = document.querySelector('[data-sticky-buy]');
  const mainButton = document.querySelector('[data-product-section] [data-add-button]');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(mainButton);
  }

  /* Heat selector */
  document.querySelectorAll('[data-heat]').forEach((section) => {
    const range = section.querySelector('[data-heat-range]');
    const level = section.querySelector('[data-heat-level]');
    const text = section.querySelector('[data-heat-text]');
    const update = () => {
      const v = parseInt(range.value, 10);
      section.style.setProperty('--heat', v);
      level.textContent = 'Niveau ' + v;
      const desc = v <= 3 ? range.dataset.low : v <= 6 ? range.dataset.mid : range.dataset.high;
      text.textContent = desc;
      range.setAttribute('aria-valuetext', 'Niveau ' + v + ' : ' + desc);
    };
    range.addEventListener('input', update);
    update();
    const img = section.querySelector('[data-zone-img]');
    section.querySelectorAll('[data-zone-src]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!img) return;
        img.src = radio.dataset.zoneSrc;
        img.alt = radio.dataset.zoneLabel;
      });
    });
  });
})();
